"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_TAG_NAME = exports.TEXT_PRIORITY = exports.TYPOGRAPHY = void 0;
var TYPOGRAPHY;
(function (TYPOGRAPHY) {
    TYPOGRAPHY["largeTitle"] = "largeTitle";
    TYPOGRAPHY["smallTitle"] = "smallTitle";
    TYPOGRAPHY["listText"] = "listText";
    TYPOGRAPHY["runningText"] = "runningText";
})(TYPOGRAPHY = exports.TYPOGRAPHY || (exports.TYPOGRAPHY = {}));
var TEXT_PRIORITY;
(function (TEXT_PRIORITY) {
    TEXT_PRIORITY["primary"] = "primary";
    TEXT_PRIORITY["secondary"] = "secondary";
})(TEXT_PRIORITY = exports.TEXT_PRIORITY || (exports.TEXT_PRIORITY = {}));
exports.DEFAULT_TAG_NAME = 'span';
//# sourceMappingURL=constants.js.map